import {CdRai} from '../../../interfaces/care/cd-rai/cd-rai';
import {LightCustomer} from '../../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../../customers/light-customer-factory';
import {LightEmployee} from '../../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../../employees/light-employee-factory';
import {LightUserFactory} from '../../core/light-user-factory';
import {LightUser} from '../../../interfaces/core/light-user';
import {UserService} from '../../../services/core/user.service';
import {CdMdsAnswer} from '../../../interfaces/care/cd-rai/cd-mds-answer';
import {CdMdsAnswerFactory} from './cd-mds-answer-factory';

export class CdRaiFactory {

  /**
   *
   * @param cdRai
   */
  public static fromObject(cdRai: any): CdRai {

    let latestCdCarePlanId: number = null;
    if(cdRai.c_clarifications?.length > 0) {
      latestCdCarePlanId = cdRai.c_clarifications[0].latest_c_care_plan?.id
    }

    return new class implements CdRai {
      canceled: string = cdRai.canceled;
      customer: LightCustomer = cdRai.customer ? LightCustomerFactory.fromObject(cdRai.customer) : null;
      customerId: number = cdRai.customer_id;
      date: string = cdRai.date;
      el: LightEmployee = cdRai.el ? LightEmployeeFactory.fromObject(cdRai.el) : null;
      elEmployeeId: number = cdRai.el_employee_id;
      elFinished: string = cdRai.el_finished;
      finished: string = cdRai.finished;
      comment: string = cdRai.comment;
      linkedCaRaiId: number = cdRai.linked_c_rai_id;
      mentor: LightEmployee = cdRai.mentor ? LightEmployeeFactory.fromObject(cdRai.mentor) : null;
      mentorEmployeeId: number = cdRai.mentor_employee_id;
      mentorFinished: string = cdRai.mentor_finished;
      mentorLocked: string = cdRai.mentor_locked;
      primaryNurse: LightEmployee = LightEmployeeFactory.fromObject(cdRai.primary_nurse);
      primaryNurseEmployeeId: number = cdRai.primary_nurse_employee_id;
      primaryNurseFinished: string = cdRai.primary_nurse_finished;
      user: LightUser = cdRai.user ? LightUserFactory.fromObject(cdRai.user) : null;
      userId: number = cdRai.user_id;
      copyLatestCdCarePlan: boolean = false;
      cdMdsAnswers: CdMdsAnswer[] = cdRai.c_mds_answers ? CdMdsAnswerFactory.fromArray(cdRai.c_mds_answers, cdRai.uuid) : [];
      hasOpenCarPlan: boolean = cdRai.has_open_c_care_plan;
      latestCdCarePlanId: number = latestCdCarePlanId;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = cdRai.id;
      uuid: string = cdRai.uuid;
      modified: string = cdRai.modified;
      created: string = cdRai.created;
      deleted: 0 | 1 = 0;
    };
  }

  public static new(): CdRai {
    return new class implements CdRai {
      canceled: string = null;
      customer: LightCustomer = null;
      customerId: number = null;
      date: string = null;
      el: LightEmployee = null;
      elEmployeeId: number =null;
      elFinished: string = null;
      finished: string = null;
      comment: string = null;
      linkedCaRaiId: number = null;
      mentor: LightEmployee = null;
      mentorEmployeeId: number = null;
      mentorFinished: string = null;
      mentorLocked: string = null;
      primaryNurse: LightEmployee = UserService.getUser().employee;
      primaryNurseEmployeeId: number = UserService.getUser().employee.id;
      primaryNurseFinished: string = null;
      user: LightUser = UserService.getUser();
      userId: number = UserService.getUser().id;
      cdMdsAnswers: CdMdsAnswer[] = [];
      copyLatestCdCarePlan: boolean = false;
      hasOpenCarPlan: boolean = false;
      latestCdCarePlanId: number = null;

      // ------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param cdRais
   */
  public static fromArray(cdRais: any[]): CdRai[] {
    return cdRais.map(_cdRai => CdRaiFactory.fromObject(_cdRai));
  }

  public static toRemote(cdRai: CdRai): any {
    return {
      id: cdRai.id,
      uuid: cdRai.uuid,
      modified: cdRai.modified,
      created: cdRai.created,
      date: cdRai.date,
      customer_id: cdRai.customerId,
      comment: cdRai.comment,
      copy_care_plan: cdRai.copyLatestCdCarePlan,
      copy_rai: cdRai.copyLatestCdCarePlan
    }
  }

}
